export type SoundDuckConfig = {
    volume: number;
    fadeDuration: number;
};
